import dark from "../img/footer-logo-dark.svg";
import light from "../img/footer-logo.svg";

export const fotterLogo = {
  light,
  dark,
};
